import * as React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Assets
import { fonts } from '../../../../styles/variables';
import { updateField } from '../../../../store/ContactForm/actions';

const InputSection = styled.div`
  padding-top: 10px;
  min-height: 50px;
`;

const InputProper = styled.input`
  display: none;
`;

const UploadMask = styled.label`
  width: 100%;
  outline: none;
  background-color: transparent;
  border: 0px;
  border-radius: 0;
  font-size: 16px;
  letter-spacing: 1px;
  display: block;
  line-height: 35px;
  cursor: pointer;
  ${({ color, textColor, fontFamily, fontStyle }) => `
    border-bottom: 1px solid ${color};
    caret-color: ${color};
    color: ${textColor};
    font-family: ${fontFamily};
    font-style: ${fontStyle};
  `};
`;

class UploadInput extends React.PureComponent {
  constructor(props) {
    super(props);
    this.selectFile = this.selectFile.bind(this);
    this.state = { gotFile: false };
  }

  handleValueChange = event => {
    const { name, form, updateStoreValue } = this.props;
    updateStoreValue({
      name,
      value: event.target.files[0],
      form
    });
    this.setState({ gotFile: true });
    // if a file has been uploaded, display the name of the file
  };

  selectFile = () => {
    this.uploadInputFile.click();
  };

  render() {
    const { name, color, text, fields } = this.props;
    const { gotFile } = this.state;
    const value = fields[[name]].error ? fields[[name]].error : gotFile ? 'file attached' : text;
    const textColor = fields[[name]].error ? '#FF6347' : color;
    const fontFamily = fields[[name]].error
      ? fonts.athelas
      : gotFile
        ? fonts.monterrat
        : fonts.athelas;
    const fontStyle = fields[[name]].error ? 'italic' : gotFile ? 'normal' : 'italic';

    return (
      <InputSection>
        <UploadMask
          text={value}
          class="simpleForm"
          color={color}
          textColor={textColor}
          htmlFor="uploadInputButton"
          fontFamily={fontFamily}
          fontStyle={fontStyle}
        >
          {value}
        </UploadMask>
        <InputProper
          placeholder={text || name}
          type="file"
          ref={ref => {
            this.uploadInputFile = ref;
          }}
          onChange={this.handleValueChange}
          color={color}
          id="uploadInputButton"
        />
      </InputSection>
    );
  }
}

UploadInput.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  updateStoreValue: PropTypes.func.isRequired,
  form: PropTypes.string.isRequired,
  fields: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired
};

const mapStateToProps = (state, ownProps) => ({
  fields: state.contactForm.forms[ownProps.form].fields
});

const mapDispatchToProps = dispatch => ({
  updateStoreValue(value) {
    dispatch(updateField(value));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UploadInput);



// WEBPACK FOOTER //
// ./src/components/ContactForm/Inputs/Upload/index.jsx